import styled from '@emotion/styled'

export const StyledBabyPoop = styled.div``
